import script from "./ValidTargetsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidTargetsView.vue?vue&type=script&setup=true&lang=js"

import "./ValidTargetsView.vue?vue&type=style&index=0&id=eaaf5fe8&lang=scss"

const __exports__ = script;

export default __exports__